type QuoteIconProps = {
  color: string;
};

export const QuoteIcon = (props: QuoteIconProps) => {
  const { color } = props;

  return (
    <svg
      width='84'
      height='76'
      viewBox='0 0 84 76'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M31.7984 0.399902L18.5984 55.8999L16.1984 42.9999C20.9984 42.9999 24.8984 44.4999 27.8984 47.4999C30.8984 50.2999 32.3984 54.0999 32.3984 58.8999C32.3984 63.6999 30.8984 67.5999 27.8984 70.5999C24.8984 73.5999 21.1984 75.0999 16.7984 75.0999C11.9984 75.0999 8.09844 73.5999 5.09844 70.5999C2.29844 67.3999 0.898438 63.4999 0.898438 58.8999C0.898438 57.0999 0.998438 55.4999 1.19844 54.0999C1.39844 52.6999 1.79844 50.9999 2.39844 48.9999C2.99844 46.9999 3.79844 44.5999 4.79844 41.7999L17.3984 0.399902H31.7984ZM82.7984 0.399902L69.5984 55.8999L67.1984 42.9999C71.9984 42.9999 75.8984 44.4999 78.8984 47.4999C81.8984 50.2999 83.3984 54.0999 83.3984 58.8999C83.3984 63.6999 81.8984 67.5999 78.8984 70.5999C75.8984 73.5999 72.1984 75.0999 67.7984 75.0999C62.9984 75.0999 59.0984 73.5999 56.0984 70.5999C53.2984 67.3999 51.8984 63.4999 51.8984 58.8999C51.8984 57.0999 51.9984 55.4999 52.1984 54.0999C52.3984 52.6999 52.7984 50.9999 53.3984 48.9999C53.9984 46.9999 54.7984 44.5999 55.7984 41.7999L68.3984 0.399902H82.7984Z'
        fill={color}
      />
    </svg>
  );
};
